import { FILTER_CONSTS } from '../constants/TopFilterConstants';
export const buildAwardTypeUrlParam = certsOnly => {
  return certsOnly ? `&awardType=${FILTER_CONSTS.AWARD_TYPES.ONLY_SHOW_CERTIFICATE_COURSES}` : '';
};
export const buildToolsUrlParam = tool => {
  return `tools=${tool}`;
};
export const buildCategoryUrlParam = category => {
  return `cat=${category}`;
};
export const buildLanguageUrlParam = language => {
  return language ? `&language=${language.toUpperCase()}` : '';
};
export const getPlaylistIdFromUrl = (win = window) => {
  const params = new URLSearchParams(win.location.search);
  const playlistIdString = params.get('playlistId');
  const playlistId = playlistIdString ? parseInt(playlistIdString, 10) : undefined;
  return playlistId;
};